import React from 'react';
import { Wallet } from 'lucide-react';
import { getBrandName } from '../utils/brand';

export function SplashScreen() {
  const brand = getBrandName();
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
      <div className="text-center">
        {/* Animated Logo */}
        <div className="relative mb-8">
          <div className="w-28 h-28 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-3xl flex items-center justify-center mx-auto shadow-2xl animate-pulse">
            <Wallet className="w-14 h-14 text-white" />
          </div>
          {/* Ripple Effect */}
          <div className="absolute inset-0 w-28 h-28 mx-auto">
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-indigo-500 to-purple-600 opacity-20 animate-ping scale-110"></div>
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-indigo-500 to-purple-600 opacity-10 animate-ping scale-125 animation-delay-200"></div>
          </div>
        </div>

        <h1 className="text-5xl font-bold text-white mb-3 tracking-tight animate-fade-in">{brand}</h1>
        <p className="text-slate-300 text-xl font-medium animate-fade-in-delay">Next-Gen Digital Wallet</p>
        
        {/* Loading Spinner */}
        <div className="mt-12">
          <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
        </div>
      </div>
    </div>
  );
}